import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERSTATUSPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderStatusPageDescriptor: _generatedOrderStatusPageDescriptor,
  orderStatusPageBlocDefinition,
  orderStatusPageDashboardLayout,
  orderStatusPageConfig,
  orderStatusPageResolveConfig,
  orderStatusPageProperties,
} = doodBlockConfig(
  {
    name: "Order confirmation page",
    internal_name: "Order confirmation page",
    url: "orders/:orderId/status",
    defaultParent: [/^Main Layout$/i],
    componentType: 'OrderStatusPageComponent',
    category: 'page',
    description: "Order confirmation page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.order-status-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.order-status-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.order-status-page.background-image.label",
        help: "pages.blocks.order-status-page.background-image.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.order-status-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.order-status-page.fieldset.appearance.label",
            fields: ["background_color", "background_image"],
          },
          {
            legend: "pages.blocks.order-status-page.fieldset.blocks.label",
            fields: ["body"],
          },
        ],
      },
    ],
  })
);

export function orderStatusPageDescriptor(): IBlockDescriptor;
export function orderStatusPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderStatusPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderStatusPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderStatusPageDescriptor, orderStatusPageProperties, fieldOrder);
}

export {
  orderStatusPageBlocDefinition,
  orderStatusPageDashboardLayout,
  orderStatusPageProperties,
  orderStatusPageConfig,
  orderStatusPageResolveConfig,
};

export type OrderStatusPageConfig = typeof orderStatusPageConfig;
